import { Component, Input } from "@angular/core";
import { Provider } from "@models";
import { MasterdataService } from "@core-services/masterdata.service";

@Component({
	selector: "voucher-tile",
	templateUrl: "./voucher-tile.component.html",
	styleUrls: ["./voucher-tile.component.scss"],
	standalone: false
})
export class VoucherTileComponent {
	@Input()
	public provider: Provider = null;

	public constructor(private masterdataService: MasterdataService) {}

	public logoUrl(): string {
		return this.masterdataService.logoUrl(this.provider);
	}

	public getName(): string {
		return this.provider.getName();
	}
}
